import ProviderOrdersLayout from "./ProviderOrdersLayout";

export default function ProviderOrdersServices() {
  return (
    <ProviderOrdersLayout>
      <div className="opacity-60 text-center py-10">
        <h2 className="text-xl font-bold mb-2">Commandes de services</h2>
        <p>Cette section sera disponible bientôt.</p>
      </div>
    </ProviderOrdersLayout>
  );
}
